import { Component, ChangeDetectionStrategy } from "@angular/core"
import { Router } from "@angular/router"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ConfirmComponent } from "@app/confirm/confirm.component"
import { ErrorComponent } from "@app/error/error.component"
import { ItaGetAuthComponent } from "@app/ita-get-auth/ita-get-auth.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { OpenInstructionsComponent } from "@app/open-instructions/open-instructions.component"
import { OpenPrivacyComponent } from "@app/open-privacy/open-privacy.component"
import { OtpComponent } from "@app/otp/otp.component"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { TaskComponent } from "@app/task/task.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"

@Component({
	selector: "app-misc-modals",
	imports: [
		COMMON_IMPORTS,
		ModalWrapComponent,
		OpenPrivacyComponent,
		OpenInstructionsComponent,
		ItaGetAuthComponent,
		TaskComponent,
		ConfirmComponent,
		ErrorComponent,
		OtpComponent,
		LangValPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./misc-modals.component.html",
})
export class MiscModalsComponent {
	modalProps: any = null
	isErrorOpen: boolean = false
	res: any = null
	constructor(
		private store: StoreService,
		public modalService: ModalService,
		public apiService: ApiService,
		public lang: LangService,
		protected router: Router
	) {}

	ngOnInit() {
		this.store.postLoginSubj.subscribe((obj: any) => this.postLogin(obj))
		this.modalService.miscModalsSubj.subscribe(
			(obj: any) => (this.modalProps = obj)
		)
	}
	acceptPartner() {
		this.apiService.post("confirm_accept_partner", {
			accept_partner_id: this.modalProps.accept_partner_id,
		})
	}
	async postLogin(obj: any) {
		const { res, accept_partner_id, download_zip } = obj
		this.res = { ...res, notificationsWasChecked: false }

		if (download_zip) {
			this.store.downloadToastFunc(async () => {
				const res: any = await this.apiService.download("download_zip")
				if (!res?.size) {
					return this.store.downloadFailedModal()
				}
				this.apiService.downloadFile(res, `all-documents.zip`)
				this.modalService.openToast("download_documents")
			})
		}
		if (accept_partner_id) {
			this.modalProps = {
				name: "confirm-partner",
				accept_partner_id,
			}
			return
		}
		this.continueSteps()
	}
	async continueSteps() {
		this.modalProps = null
		if (this.res?.needsPrivacy) {
			this.res.needsPrivacy = null
			this.modalProps = { name: "open-privacy" }
			return
		}
		if (this.res?.doesOwnerNeedToPay) {
			this.res.doesOwnerNeedToPay = null
			const newRenewLang =
				this.res.doesOwnerNeedToPay === "new"
					? "payment_request_text_new"
					: "payment_request_text_renew"
			const freeText = `${this.lang.getVal("hello")},</br>${this.lang.getVal(newRenewLang)}</br>
			<p class="pt-2">${this.lang.getVal("if_paid_ignore")}</p></br>`
			this.modalProps = { name: "confirm-payment", freeText }
			return
		}

		if (this.res?.needsItaToken || this.res?.needsItaRefreshToken) {
			this.res.needsItaToken = null
			this.res.needsItaRefreshToken = null
			this.modalProps = { name: "ita-get-auth" }
			return
		}
		if (!this.res.notificationsWasChecked) {
			this.res.notificationsWasChecked = true
			const { notifications_upon_login } = this.store.cc()
			if (notifications_upon_login === "yes") {
				const { total } = await this.apiService.post(
					"get_task_notifications_total"
				)
				if (total) {
					this.modalProps = { name: "task" }
					return
				}
			}
		}
		if (this.res?.openInstructions) {
			/* checkin if this is good for us  */
			this.res.openInstructions = null
			this.modalProps = { name: "open-instructions" }
			return
		}
	}
}
